(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/check-iam/assets/javascripts/check-iam.js') >= 0) return;  svs.modules.push('/components/accountservices/check-iam/assets/javascripts/check-iam.js');

'use strict';

var _svs, _svs$accountservices, _svs$accountservices$, _svs$accountservices$2;
svs || (svs = {});
(_svs = svs).accountservices || (_svs.accountservices = {});
(_svs$accountservices = svs.accountservices).check_iam || (_svs$accountservices.check_iam = {});
(_svs$accountservices$ = svs.accountservices.check_iam).data || (_svs$accountservices$.data = {});
(_svs$accountservices$2 = svs.accountservices.check_iam.data).config || (_svs$accountservices$2.config = {});

const config = svs.accountservices.check_iam.data.config;

svs.accountservices.check_iam.isIamBasicEnabled = config.isIamBasicEnabled || false;
svs.accountservices.check_iam.isIamIFrameEnabled = config.isIamIFrameEnabled || false;
svs.accountservices.check_iam.isIamBasicOrIFrameEnabled = config.isIamBasicOrIFrameEnabled || false;
svs.accountservices.check_iam.isInSweden = config.isInSweden; 
svs.accountservices.check_iam.countryCode = config.countryCode; 

 })(window);